import { sectionType } from '@/views/website/products/components/description/common/types';

import { buildAccordionFaqGrid03, buildAccordionFaqGrid04 } from './accorditons';
import { buildBannerB1, buildCardBannerRivoneedSection, buildCardsectionCardBanner02Rivoneed } from './hero-banner';
import { buildMarqueeBasicTextSection } from './marquee';
import {
  buildCardSmokingSection,
  buildCustomizeCardSection,
  buildCardBasicRivoneedSection,
  buildCardWithSurveySection,
  buildCardWithTableCompare,
  buildCardVideoSection,
  buildSatelliteGridSection,
  buildImageWithTextCol1Section,
  buildFaqCardSection,
} from './side-by-side';
import { buildIconWithTextB1, buildCardBadgeRivoneed } from './icon-grid';
import { buildReviewGrid02, buildCardMediaSlider03, buildCardSliderYuri, buildMarqueeShopzovya } from './carousel';
import { buildCardSatelliteRivoneed, buildTinoGridSection } from './feature-grid-media';
import { buildSectionFreestyle } from './freestyle_content';
import { buildProductReviews } from './review_list';
import { buildImageWithTextCol1Section as buildImageWithTextCol1SectionV2 } from './text-media-stack';
import { buildSatelliteGridCenterSection } from './media-center-grid';

const typeSignal = {
  side_by_side: 'side_by_side',
  hero_banner: 'hero_banner',
  marquee: 'marquee',
  media_center_grid: 'media_center_grid',
  faq_accordion: 'faq_accordion',
  carousel: 'carousel',
  feature_grid_media: 'feature_grid_media',
  icon_grid_row: 'icon_grid_row',
  stat_list: 'stat_list',
  review_list: 'review_list',
  freestyle_content: 'freestyle_content',
  text_media_stack: 'text_media_stack',
};

const builderRegistry = {
  [typeSignal.side_by_side]: {
    [sectionType.sectionCardSmoking]: buildCardSmokingSection,
    [sectionType.sectionCustomizeCard]: buildCustomizeCardSection,
    [sectionType.sectionCardBasicRivoneed]: buildCardBasicRivoneedSection,
    [sectionType.sectionCardWithSurvey]: buildCardWithSurveySection,
    [sectionType.sectionCardWithTableCompare]: buildCardWithTableCompare,
    [sectionType.sectionCardVideo]: buildCardVideoSection,
    [sectionType.sectionSatelliteGrid]: buildSatelliteGridSection,
    [sectionType.sectionImageWithTextCol1]: buildImageWithTextCol1Section,
    [sectionType.sectionFaqCard]: buildFaqCardSection,
  },
  [typeSignal.hero_banner]: {
    [sectionType.sectionBannerB1]: buildBannerB1,
    [sectionType.sectionCardBannerRivoneed]: buildCardBannerRivoneedSection,
    [sectionType.sectionCardBanner02Rivoneed]: buildCardsectionCardBanner02Rivoneed,
  },
  [typeSignal.marquee]: {
    [sectionType.sectionMarqueeBasicText]: buildMarqueeBasicTextSection,
  },

  [typeSignal.faq_accordion]: {
    [sectionType.sectionFaqGrid03]: buildAccordionFaqGrid03,
    [sectionType.sectionFaqGrid04]: buildAccordionFaqGrid04,
  },
  [typeSignal.carousel]: {
    [sectionType.sectionReviewGrid02]: buildReviewGrid02,
    [sectionType.sectionCardMediaSlider03]: buildCardMediaSlider03,
    [sectionType.sectionCardSliderYuri]: buildCardSliderYuri,
    [sectionType.sectionMarqueeShopzovya]: buildMarqueeShopzovya,
  },
  [typeSignal.feature_grid_media]: {
    [sectionType.sectionCardSatelliteRivoneed]: buildCardSatelliteRivoneed,
    [sectionType.sectionTinoGrid]: buildTinoGridSection,
  },
  [typeSignal.icon_grid_row]: {
    [sectionType.sectionIconWithTextB1]: buildIconWithTextB1,
    [sectionType.sectionCardBadgeRivoneed]: buildCardBadgeRivoneed,
  },
  [typeSignal.review_list]: {
    [sectionType.sectionProductReviews]: buildProductReviews,
  },
  [typeSignal.freestyle_content]: {
    [sectionType.sectionFreestyle]: buildSectionFreestyle,
  },
  [typeSignal.text_media_stack]: {
    [sectionType.sectionImageWithTextCol1]: buildImageWithTextCol1SectionV2,
  },
  [typeSignal.stat_list]: {},
  [typeSignal.media_center_grid]: {
    [sectionType.sectionSatelliteGrid]: buildSatelliteGridCenterSection,
  },
};

export const buildSectionByType = (type, sectionTemplates, suggestionFields, suggestionTags) => {
  const builder = builderRegistry[suggestionFields.type_signal]?.[type];
  if (!builder) return null;

  const baseTemplate = sectionTemplates.find(t => {
    return t.type === type;
  });

  if (!baseTemplate) return null;

  return builder(baseTemplate, suggestionFields, suggestionTags);
};
